import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/galleries")({
  component: lazyRouteComponent(() => import("./-pages/admin.galleries")),
  head: () => ({
    meta: [{ title: "Collection Galleries · Lecmo Admin" }, { name: "robots", content: "noindex" }],
  }),
});
